import { TextField, InputAdornment } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";

interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  sx?: SxProps<Theme>;
}

export function SearchField({
  value,
  onChange,
  placeholder,
  sx,
}: SearchFieldProps) {
  return (
    <TextField
      placeholder={placeholder}
      size="small"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      sx={[
        { mb: 3, maxWidth: 360 },
        ...(sx ? (Array.isArray(sx) ? sx : [sx]) : []),
      ]}
      fullWidth
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        },
      }}
    />
  );
}
